var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"footer"},[_c('ul',{staticClass:"footer-links"},[_c('li',[_c('a',{attrs:{"href":"https://www.hilfeimpaket.de/impressum/"}},[_vm._v("Impressum")])]),_c('li',[_c('a',{attrs:{"href":"https://www.hilfeimpaket.de/datenschutz/"}},[_vm._v("Datenschutz")])])])])])
}]

export { render, staticRenderFns }